"use strict";import{DesktopController as o}from"./DesktopController.js";import{MobileController as r}from"./MobileController.js";export const strategies={desktop:o,mobile:r};
//# sourceMappingURL=strategies.js.map
